document.addEventListener('DOMContentLoaded', function() {
  // Função para implementar o acordeão
  function initAccordion() {
    const descriptionMain = document.querySelector('.description-main');
    const btVerMais = document.querySelector('.bt-vermais');
    
    if (!descriptionMain || !btVerMais) {
      return; // Se os elementos não existirem, não faz nada
    }
    
    // Verificar se já foi inicializado
    if (descriptionMain.hasAttribute('data-accordion-initialized')) {
      return;
    }
    
    // Marcar como inicializado
    descriptionMain.setAttribute('data-accordion-initialized', 'true');
    
    // Estado inicial
    let isExpanded = false;
    const originalHeight = descriptionMain.scrollHeight;
    
    // Verificar se há conteúdo suficiente para justificar o botão
    const tolerance = 10; // pixels de tolerância
    
    if (originalHeight <= (70 + tolerance)) {
      btVerMais.style.display = 'none';
      descriptionMain.style.height = 'auto';
      descriptionMain.style.overflow = 'visible';
      return;
    }
    
    // Configurar altura inicial
    descriptionMain.style.height = '70px';
    descriptionMain.style.overflow = 'hidden';
    descriptionMain.style.transition = 'height 0.3s ease-in-out';
    
    // Verificar se o evento já foi adicionado
    if (btVerMais.hasAttribute('data-click-initialized')) {
      return;
    }
    
    // Marcar que o evento foi adicionado
    btVerMais.setAttribute('data-click-initialized', 'true');
    
    // Adicionar evento de clique
    btVerMais.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (isExpanded) {
        // Recolher
        descriptionMain.style.height = '70px';
        descriptionMain.classList.remove('expanded');
        btVerMais.querySelector('span').textContent = 'Ver mais';
        btVerMais.classList.remove('expanded');
        isExpanded = false;
      } else {
        // Expandir
        descriptionMain.style.height = originalHeight + 'px';
        descriptionMain.classList.add('expanded');
        btVerMais.querySelector('span').textContent = 'Ver menos';
        btVerMais.classList.add('expanded');
        isExpanded = true;
      }
    });
    
    // Adicionar cursor pointer ao botão
    btVerMais.style.cursor = 'pointer';
    btVerMais.style.userSelect = 'none';
  }
  
  // Inicializar o acordeão
  initAccordion();
  
  // Re-inicializar se houver mudanças dinâmicas no DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Verificar se os elementos foram adicionados
        const descriptionMain = document.querySelector('.description-main');
        const btVerMais = document.querySelector('.bt-vermais');
        
        if (descriptionMain && btVerMais && !descriptionMain.hasAttribute('data-accordion-initialized')) {
          initAccordion();
        }
      }
    });
  });
  
  // Observar mudanças no DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 